// eslint-disable-next-line import/no-cycle
import {
  ComponentNameEnum, ConfigurationPanelStructureItemEnum, FieldsGroup, SocialNetworkIconStyleEnumV4,
  TemplateStructureEnum, ElementPartTypeEnum, TabItem,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getHorizontalSpacesFieldConfig from '@/components/template-builder/config/fields/horizontal-spaces-config';
// eslint-disable-next-line import/no-cycle
import getVerticalSpacesFieldConfig from '@/components/template-builder/config/fields/vertical-spaces-config';
// eslint-disable-next-line import/no-cycle
import getElementAlignFieldConfig from '@/components/template-builder/config/fields/element-align-config';
// eslint-disable-next-line import/no-cycle
import bordersFieldConfig from '@/components/template-builder/config/fields/borders-config';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import {
  setAttribute,
  setClass,
  setCssProperty,
  setCssPropertyAndRemoveIfZero,
  setMediaDisplay,
  setSocialNetworkIconStyleV4,
  setSocialNetworkIconWidth,
  setSocialNetworkOrientation,
  setSocialNetworkItemsV4,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getAttributeByName,
  getClassByName,
  getCssPropertyByName,
  getSocialNetworkIconStyleV4,
  getSocialNetworksItemsV4,
  isMediaDisplayAlreadyRestricted,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import iconLayoutFieldConfig from '@/components/template-builder/config/fields/icon-layout-config';
// eslint-disable-next-line import/no-cycle
import socialNetworkInputGroupConfig from '@/components/template-builder/config/fields/social-network-input-group-config';
// eslint-disable-next-line import/no-cycle
import iconSizeFieldConfig from '@/components/template-builder/config/fields/icon-size-config';
// eslint-disable-next-line import/no-cycle
import getSpmSocialIconsFieldConfigV4 from '@/components/template-builder/config/fields/spm-social-icons-config-v4';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';
// eslint-disable-next-line import/no-cycle
import getWidgetCommonStylesGroup from '@/components/template-builder/config/fields/widget-common-styles-config';

const widgetSocialMediaFieldsConfig: Array<FieldsGroup | TabItem> = [
  {
    type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
    label: 'templateBuilder.configs.widgetConfiguration',
    selector: 'body #spm_body #{ID}',
    items: [
      {
        label: 'templateBuilder.fields.iconLayout',
        selector: '{SELECTOR} > tbody > tr > th > table',
        properties: [{
          name: 'spm_social_icons_', getter: getClassByName, setters: [setClass, setSocialNetworkOrientation],
        }],
        ...iconLayoutFieldConfig,
      },
      {
        label: 'templateBuilder.fields.iconSize.label',
        selector: '{SELECTOR} > tbody > tr > th > table img',
        displayToggle: false,
        properties: [
          {
            name: 'width', getter: getAttributeByName, setters: [setAttribute, setSocialNetworkIconWidth],
          },
        ],
        ...iconSizeFieldConfig,
      },
      {
        label: 'templateBuilder.fields.iconStyle',
        selector: '{SELECTOR} > tbody > tr > th > table img',
        displayToggle: false,
        properties: [{ name: 'iconStyle', getter: getSocialNetworkIconStyleV4, setters: [setSocialNetworkIconStyleV4] }],
        ...getSpmSocialIconsFieldConfigV4(
          Object.values(SocialNetworkIconStyleEnumV4),
          SocialNetworkIconStyleEnumV4.STYLE_1,
        ),
      },
      {
        label: 'templateBuilder.fields.socialNetworksConfiguration',
        selector: '{SELECTOR} > tbody > tr > th > table',
        properties: [
          {
            name: 'socialNetworkItems',
            getter: getSocialNetworksItemsV4,
            setters: [setSocialNetworkItemsV4],
            refreshWidgetFields: true,
          },
        ],
        ...socialNetworkInputGroupConfig,
      },
    ],
  },
  {
    type: ConfigurationPanelStructureItemEnum.TAB_ITEM,
    tabItemType: TemplateStructureEnum.GROUP,
    label: 'templateBuilder.configs.widgetStyles',
    canSave: true,
    elementPartType: ElementPartTypeEnum.STYLES,
    tabPanel: {
      items: [
        {
          type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
          label: 'templateBuilder.configs.widgetBlockStyles',
          selector: 'body #spm_body #{ID}',
          items: [
            {
              label: 'templateBuilder.fields.contentAlignment',
              selector: '{SELECTOR} table',
              properties: [{ name: 'align', getter: getAttributeByName, setters: [setAttribute] }],
              ...getElementAlignFieldConfig(),
            },
            {
              label: 'templateBuilder.fields.iconInnerMargins',
              selector: '{SELECTOR} > tbody > tr > th td.spm_social_icon',
              properties: [
                {
                  name: 'padding-right',
                  getter: getCssPropertyByName,
                  setters: [setCssProperty],
                },
                { name: 'padding-left', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'padding-top', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'padding-bottom', getter: getCssPropertyByName, setters: [setCssProperty] },
              ],
              componentName: ComponentNameEnum.SPACES,
              options: {
                ...getVerticalSpacesFieldConfig('padding').options,
                ...getHorizontalSpacesFieldConfig('padding').options,
              },
            },
            {
              label: 'templateBuilder.fields.marginVertical',
              selector: '{SELECTOR} th, {SELECTOR} table',
              properties: [
                { name: 'margin-top', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'margin-bottom', getter: getCssPropertyByName, setters: [setCssProperty] },
              ],
              ...getVerticalSpacesFieldConfig('margin'),
            },
            {
              label: 'templateBuilder.fields.marginHorizontal',
              selector: '{SELECTOR} th, {SELECTOR} table',
              properties: [
                { name: 'margin-left', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'margin-right', getter: getCssPropertyByName, setters: [setCssProperty] },
              ],
              ...getHorizontalSpacesFieldConfig('margin'),
            },
            {
              label: 'templateBuilder.fields.borders',
              selector: '{SELECTOR}',
              properties: [
                { name: 'border-color', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-style', getter: getCssPropertyByName, setters: [] },
                { name: 'border-width', getter: getCssPropertyByName, setters: [setCssPropertyAndRemoveIfZero] },
                { name: 'border-bottom-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-bottom-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-bottom-width', getter: getCssPropertyByName, setters: [] },
                { name: 'border-top-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-top-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-top-width', getter: getCssPropertyByName, setters: [] },
                { name: 'border-left-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-left-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-left-width', getter: getCssPropertyByName, setters: [] },
                { name: 'border-right-style', getter: getCssPropertyByName, setters: [setCssProperty] },
                { name: 'border-right-color', getter: getCssPropertyByName, setters: [] },
                { name: 'border-right-width', getter: getCssPropertyByName, setters: [] },
              ],
              ...bordersFieldConfig,
            },
          ],
        },
        getWidgetCommonStylesGroup('{SELECTOR} > tbody > tr > th'),
      ],
    },
  },
  getConditionsAndRepetitionGroup('body #spm_body #{ID}'),
];

export default widgetSocialMediaFieldsConfig;
